@if (license) {
  <a [href]="getUrl()" [title]="license.value" class="inline" rel="license" target="_blank">
    <img [alt]="license.value" [src]="license.logo" class="h-16" style="border-width: 0" />
  </a>
}
